<template>
  <video v-if="loaded"
         controlsList="nodownload"
         oncontextmenu="return false;"
         id="videoPlayer"
         style="height : 100%; width : 100%"
         :src="launchData.activityLink"
         @loadeddata="initVideo"
         @play="startTimer"
         @pause="pauseTimer"
         @ended="postData"
         type="video/mp4" controls  autoplay></video>
</template>
<script>

import { mapGetters } from 'vuex';
import {
  FETCH_COURSES,
  FETCH_SIMPLE_ACTIVITY,
  SEND_ACTIVITY_TRACE, SET_COURSE,
} from '@/store/actions.type';
import store from '@/store';

export default {
  name: 'VideoViewer',
  components: {
  },
  created() {
    this.loaded = false;
    this.completed = false;
    store.dispatch(FETCH_SIMPLE_ACTIVITY).then(() => {
      this.loaded = true;
      this.$Progress.finish();
    });
  },
  destroyed() {
    clearInterval(this.interval);
  },
  data() {
    return {
      loaded: false,
      videoPlayer: null,
      gameId: '',
      startTime: Date.now(),
      elapsedTime: 0,
      progress: 0,
      completed: false,
      interval: null,
    };
  },
  watch: {
    $route() {
      this.loaded = false;
      this.completed = false;
      store.dispatch(FETCH_SIMPLE_ACTIVITY).then(() => {
        this.loaded = true;
        this.$Progress.finish();
      });
    },
  },
  computed: {
    ...mapGetters(['launchData', 'currentSession']),
  },
  methods: {
    postData() {
      this.completed = true;
      if (this.videoPlayer == null) return;
      const newProgress = (Math.round((this.videoPlayer.currentTime
        / this.videoPlayer.duration) * 100));
      if (newProgress === null || this.gameId === '' || newProgress === this.progress) return;
      this.progress = newProgress;
      this.pauseTimer();
      const data = {
        currentPosition: this.videoPlayer.currentTime,
        progress: newProgress,
        gameId: this.gameId,
        session_time: this.elapsedTime,
      };
      store.dispatch(SEND_ACTIVITY_TRACE, data)
        .then(() => {
          store.dispatch(FETCH_COURSES).then(() => {
            store.dispatch(SET_COURSE, this.course.id).then(() => this.$Progress.finish());
          });
        })
        .catch(() => {
          this.$dialog.alert(this.$t('app.activity.commit.error'), {
            backdropClose: true,
            okText: this.$t('app.activity.commit.ok'),
          });
        });
    },
    initVideo(event) {
      this.videoPlayer = event.target;
      this.interval = setInterval(() => { this.postData(); }, 120000);
      const launchData = JSON.parse(this.launchData.launchData);
      this.gameId = launchData.gameId;
      if (launchData.session_time && launchData.session_time > 0) {
        this.elapsedTime = launchData.session_time;
      }
      if (launchData.currentPosition > 0) {
        this.videoPlayer.currentTime = launchData.currentPosition;
        this.progress = (Math.round((this.videoPlayer.currentTime
          / this.videoPlayer.duration) * 100));
      }
    },
    startTimer() {
      this.startTime = Date.now();
    },
    pauseTimer() {
      this.elapsedTime += parseInt((Date.now() - this.startTime) / 1000, 10);
      this.startTime = Date.now();
    },
  },
};
</script>
